define('bizzabo/views/right/EditPartnerView',[
    'jquery',
    'backbone',
    'underscore',
    'bizzabo/utils',
    'bizzabo/consts',
    'bizzabo/bzapi',
    'bizzabo/models/Global',
    'bizzabo/models/Speaker',
    'bizzabo/views/FormMixin',
    'bizzabo/views/ModelBindingMixin',
    'bizzabo/views/UploadFileCloudinaryView',
    'hbars!bizzabo/templates/editPartner',
    'bizzabo/config',
    'https://widget.cloudinary.com/global/all.js',
], function(
    $,
    Backbone,
    _,
    UTILS,
    Consts,
    BZAPI,
    Global,
    Speaker,
    FormMixin,
    ModelBindingMixin,
    UploadFileCloudinaryView,
    template,
    CONFIG,
    GlobalCloudinary
) {

    var EditPartnerView = Backbone.View.extend({

        uploadFileView : undefined,
        tagName : "article",
        className : "editSponsorDetails",

        events : {
            'change select[name=tier]' : 'formTierChanged',
            'click a.deleteSponsor' : 'deleteSponsorClicked',
            'click .save-button' : 'saveButtonClicked',
            'click .eventLogoBox a' : 'editLogoClicked'
        },

        initialize : function() {
            this.initializeForm();
            this.initializeUploadCloudinaryView();

            this.model.on("change:logo-url", this.renderLogo, this);
            this.model.on("change:tier", this.renderTier, this);

            Backbone.on(Consts.Notifications.rightPanel.SWITCHED, this.onReady, this);
        },

        initializeForm : function() {
            var fields = [
                'company-name',
                'location-at-event',
                'description',
                'offer-text',
                'phone',
                'email',
                'website-url',
                'facebook-url',
                'twitter-handle',
                'linkedin-url',
                'custom-button-1-name',
                'custom-button-1-url',
                'custom-button-2-name',
                'custom-button-2-url'
            ];
            this.keyPressValidationFields = fields;
            this.modelBindingWhiteList = fields;
            this.bindAllValidationFields = false;

            UTILS.mixIntoMe(this, FormMixin);
            UTILS.mixIntoMe(this, ModelBindingMixin);
            this.initModelBinding();
            this.initValidation();
        },

        initializeUploadCloudinaryView : function() {
            this.cloudinary = new UploadFileCloudinaryView({
                max_image_width: 400,
                max_image_height: 256,
                recommendedSize: 'Recommended image size: 400W X 256H. Must be JPG, GIF, or PNG.'
            });
            this.listenTo(this.cloudinary, 'success', this.renderImage);
        },

        renderImage: function () {
            this.model.set('logo-url', this.cloudinary.image);
        },

        remove : function() {
            if (document.activeElement != document.body) {
                $(document.activeElement).blur();
            }

            Backbone.off(Consts.Notifications.rightPanel.SWITCHED, this.onReady, this);

            this.model.off("change:logo-url", this.renderLogo, this);
            this.model.off("change:tier", this.renderTier, this);

            this.removeForm();
            this.cloudinary.remove();

            this.off();
            this.$el.remove();
        },

        removeForm : function() {
            this.removeModelBinding();
            this.removeValidation();
        },

        formTierChanged : function() {
            var tierSelectElement = this.$('select[name=tier]');
            var selectValue = tierSelectElement.val();
            if (selectValue && selectValue != "") {
                var newValue = parseInt(selectValue);
                this.model.set({
                    'tier' : newValue
                });
            } else {
                this.model.unset("tier");
            }
        },

        deleteSponsorClicked : function() {
            Backbone.trigger(Consts.Notifications.sponsors.DELETE_SPONSOR, this.model);
            this.removeAndClose();
        },

        saveButtonClicked : function() {
            Backbone.trigger(Consts.Notifications.mainPage.SAVE_ALL_REQUEST);
        },

        removeAndClose : function() {
            Backbone.trigger('sponsorsRightPanelClosed');
            this.remove();
        },

        setFocusToField : function(fieldSelector) {
            var focusField = this.$(fieldSelector);
            var scroller = this.$('.possibleScroll');
            _.defer(function() {
                var offsetFromTop = 25;
                scroller.animate({
                    scrollTop : focusField.offset().top - scroller.offset().top + scroller.scrollTop() - offsetFromTop
                }, 700, function() {
                    var focusFieldValue = focusField.val();
                    focusField.focus();
                    focusField.val(focusFieldValue);
                });
            });
        },

        // Edit Logo



        // Rendering

        renderLogo : function() {
            var logoURL = 'images/sponsors/placeholder_' + this.model.get('partner-type')+ '.png';
            var hasLogo = (this.model && this.model.has('logo-url'));
            if (hasLogo) {
                logoURL = this.model.get('logo-url');
            }
            this.$('.eventLogoBox').toggleClass('hasLogo', hasLogo);

            var thisImage = this.$('img.eventLogo');
            thisImage.fadeOut('slow', function() {
                thisImage.attr("src", logoURL);
                thisImage.removeClass('hide');
                thisImage.fadeIn('slow');
            });
        },

        renderSubViews : function() {
            this.$('.uploadFile').html(this.cloudinary.render().el);
        },

        renderTier : function() {
            if (this.model.get("partner-type") != "sponsor") {
                return;
            }
            var tierSelectElement = this.$('select[name=tier]');
            var oldValue = tierSelectElement.val();
            var newValue = this.model.get('tier') || "";
            if (oldValue != newValue) {
                tierSelectElement.val(newValue);
                tierSelectElement.trigger("chosen:updated");
            }
        },

        render : function() {
            var tiers = this.options.event.get('tier-configuration').toJSON();
            var extendedJSON = _.extend(this.model.toJSON(), {
                'tier-configuration' : tiers
            });
            var html = template(extendedJSON);
            this.$el.html(html);
            this.renderSubViews();
            this.renderLogo();

            return this;
        },

        onReady : function() {
            this.renderForm();
            this.renderTier();
            this.disableViewIfNeed();

            var shouldValidate = this.model.wasEdited || this.model.isSynced;
            shouldValidate && this.model.validate();

            var autoFocusField = this.options.deepLinkParams && this.options.deepLinkParams.field;
            autoFocusField && this.setFocusToField('[name=' + autoFocusField + ']');
        },

        disableViewIfNeed : function() {
            if (Global.modelPool.getActiveEvent().get('event-is-active')) {
                this.$('input, textarea').attr('disabled', 'disabled');
                this.$('.centerAlign, .deleteLabel').toggleClass('hide', true);
            } else {
                this.$('input, textarea').removeAttr('disabled', 'disabled');
                this.$('.centerAlign, .deleteLabel').toggleClass('hide', false);
            }
        }
    });

    return EditPartnerView;

});
